
import Vue from 'vue'
import { Loading } from '@/components'

export default Vue.extend({
   name: 'StorePaymentProcessingBanner',
   components: {
      Loading,
   },
})
